// Data Valadation

export default (data, value) => {
  Object.keys(data).forEach((key) => {
    if (key === value.key) {
      data[key].error = null;
      if (data[key].validate) {
        if (value.value !== "") {
          if (
            data[key].req &&
            ["phone", "text", "email"].indexOf(data[key].type) > -1
          ) {
            if (
              data[key].req.test(value.value) ||
              (data[key].type === "number" &&
                data[key].req.test(String(value.value).replace(/[^+\d]/g, "")))
            ) {
              data[key].error = "";
            } else {
              data[key].error =
                data[key].type === "email"
                  ? "Некорректный email"
                  : "Поле заполнено некорректно";
            }
          } else {
            data[key].error = "";
          }
          if (data[key].error === "" && value.repeat) {
            if (
              value.repeat &&
              String(value.value) !== String(data[value.repeat].value)
            ) {
              data[key].error = value.repeatError;
            }
          }
          if (data[key].error === "" && data[key].min) {
            if (String(value.value).length < data[key].min) {
              data[key].error =
                "Минимально " +
                data[key].min +
                (data[key].min > 4 ? " символов" : " символа");
            }
          }
          if (["select", "image"].indexOf(data[key].type) > -1) {
            data[key].error = "";
            if (data[key].required) {
              if (value.value === "" || value.value === null) {
                data[key].error =
                  data[key].type === "image"
                    ? "Загрузите изображение"
                    : "Выберите значение";
              }
            }
          }
          if (["password"].indexOf(data[key].type) > -1) {
            data[key].errorType = [null, null, null, null];
            if (value.value.length < 8 || value.value.length > 20) {
              data[key].errorType[0] = true;
            } else {
              data[key].errorType[0] = "";
            }
            if (/[A-Za-z]/.test(value.value) && /[\d]/.test(value.value)) {
              data[key].errorType[1] = "";
            } else {
              data[key].errorType[1] = true;
            }
            if (/[A-Z]/.test(value.value)) {
              data[key].errorType[2] = "";
            } else {
              data[key].errorType[2] = true;
            }
            if (/[.,:;?!*+%\-<>@[\]{}/\\_$#]/g.test(value.value)) {
              data[key].errorType[3] = "";
            } else {
              data[key].errorType[3] = true;
            }
          }
        }
      }
      if (data[key].special) {
        if (value.value.value === null) {
          data[data[key].specialKey].value = true;
        } else {
          data[data[key].specialKey].value = false;
        }
      }
    }
  });
  data[value.key].value = value.value;
  return data;
};
